import React, {Component} from 'react';
import * as api from "../../../utils/api/api";
import { FormField } from "components/common/FormField.component";
import { TextInput } from "components/common/TextInput.component";

export class SimulatorAmount extends Component {

    componentDidMount() {
        this.getCurrency();
    }

    getCurrency(){
        api.getCurrencyCode(this.props.currentContextId).then((response) => {
            if(response){
                this.props.onCurrencyChange({
                    target: {
                        value: response
                    }
                })
            }
        })
    }

    render() {
        return (
            <div className="form-group">
                <div className="form-group form-inline d-flex gap-8">
                    <FormField
                        id="simulator-amount"
                        label={this.props.translate("workflowDetails.simulator.amount")}>
                        <TextInput
                            type="number"
                            className="ga-input__amount"
                            value={this.props.amount}
                            onChange={this.props.onAmountChange}
                            invalid={!this.props.valid}
                            min={1}
                        />
                    </FormField>
                    <div className="form-group mb-16 align-self-end">
                        <select className="form-control"
                                value={this.props.currency}
                                onChange={this.props.onCurrencyChange}>
                            <option value={'NOK'}>NOK</option>
                            <option value={'SEK'}>SEK</option>
                            <option value={'DKK'}>DKK</option>
                            <option value={'EUR'}>EUR</option>
                            <option value={'RON'}>RON</option>
                        </select>
                    </div>
                </div>
            </div>
        );
    }
}